import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "format-align-justify",
  "use": "format-align-justify-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"format-align-justify\"><path fill-rule=\"evenodd\" d=\"M21 21v-2H3v2h18Zm0-4v-2H3v2h18Zm0-4v-2H3v2h18Zm0-4V7H3v2h18ZM3 5h18V3H3v2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol